import { useCallback } from 'react';

import { moveModule } from '~store/thunks/module';
import useAppDispatch from './useAppDispatch';

const useMoveModule = ({
  parentId,
  fieldName = 'relationships.field_modules.data',
  id,
}: {
  parentId: string;
  fieldName?: string;
  id: string;
}) => {
  const dispatch = useAppDispatch();
  return useCallback(
    (targetIndex = 0) => {
      dispatch(moveModule({ parentContext: parentId, fieldName, id, targetIndex }));
    },
    [dispatch, fieldName, id, parentId],
  );
};

export default useMoveModule;
